
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";


const useStyles = CreateResponsiveStyle(
  {
    contentWrapper: {
      width: "100%",
    },
    wrapper: {
      paddingHorizontal: 73,
    },
    skipButtonWrapper: {},
    tncWrapper: {
      alignSelf: "flex-start",
      paddingHorizontal: 25,
    },
    overlayContentStyle: {
      width: "80%",
      height: "95%",
      backgroundColor: "white",
      borderRadius: 15,
      alignSelf: "center",
      justifyContent: "center",
      marginVertical: 10

    },
    pdfViewStyle: {
      height: "60%",
      width: "100%",
    },
    headerWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: 70,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.06)",
      shadowOffset: {
        width: 0,
        height: 3,
      },
      shadowRadius: 6,
      shadowOpacity: 1,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
      alignItems: "center",
    },
    bodyWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 40,
    },
    insuranceCardWrapper: { width: "40%", gap: 18, minHeight: 275, maxHeight: 275 },
    infoWrapper: { width: "60%", height: 280 },
    cardWrapper: { gap: 10, marginTop: 10 },
    footer: {
      alignSelf: "flex-end",
      height: 40,
      marginVertical: 15,
      flexDirection: "row",
    },
    proccedBtnWrapper: {
      width: 200,
      marginLeft: 32,
      minHeight: 40,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      contentWrapper: {
        flexDirection: "column",
        width: "100%",
        height: "100%",
        alignSelf: "center",
        marginLeft: 5,
        marginVertical: 10,
        marginRight: 5,
      },
      bodyWrapper: {
        flexDirection: "column",
        width: "100%",
        paddingHorizontal: 0,
        alignSelf: "center",
      },
      wrapper: {
        paddingHorizontal: 13,
      },
      insuranceCardWrapper: {
        width: "100%",
        height: 275,
        minHeight: 300,
        maxHeight: 300,
      },
      infoWrapper: { width: "100%" },
    },
    [DEVICE_SIZES.SM]: {
      contentWrapper: {
        flexDirection: "column",
        width: "100%",
        height: "100%",
        alignSelf: "center",
        marginLeft: 5,
        marginVertical: 10,
        marginRight: 5,
      },
      bodyWrapper: {
        flexDirection: "column",
        width: "100%",
        paddingHorizontal: 0,
        alignSelf: "center",
      },
      insuranceCardWrapper: {
        width: "100%",
        alignSelf: "center",
        height: 275,
        minHeight: 300,
        maxHeight: 300,
      },
      wrapper: {
        paddingHorizontal: 13,
      },
    },
    [DEVICE_SIZES.XS]: {
      contentWrapper: {
        flexDirection: "column",
        width: "100%",
        height: "100%",
        alignSelf: "center",
        marginLeft: 5,
        marginVertical: 10,
        marginRight: 5,
      },
      wrapper: {
        paddingHorizontal: 13,
      },
      bodyWrapper: {
        flexDirection: "column",
        width: "100%",
        paddingHorizontal: 0,
        alignSelf: "center",
      },
      insuranceCardWrapper: {
        width: "100%",
        alignSelf: "center",
        minHeight: 200,
        maxHeight: 300,
      },
      infoWrapper: {
        width: "100%",
        minHeight: 400,
      },
      footer: {
        alignSelf: "center",
        flexDirection: "column",
        minHeight: 40,
        paddingBottom: 30,
      },
      proccedBtnWrapper: {
        marginVertical: 14,
        marginLeft: 0,
      },
      overlayContentStyle: {
        width: "90%",
      },
    },
  }
);

export default useStyles